import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import { postData, getData, patchData, deleteData } from '../../util/Fetch';
import swal from 'sweetalert';
import { CompactPicker } from 'react-color';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const ServiceModal = (props) => {
    const [open, setOpen] = React.useState(false);
    const [newService, setNewService] = React.useState({
        serviceName: '',
        timeConsuming: 0,
        priceLowerBound: 0,
        priceUpperBound: 0,
        number: 0,
        color: '#2196F3'
    });

    useEffect(() => {
        if(props.editData){
            setNewService(props.editData);
            openModel();
        }
    }, [props]);

    const openModel = () => {
        setOpen(true);
    };

    const handleChangeColor = (color) => {
        setNewService({...newService, color: color.hex});
    }

    const closeModel = () => {
        props.setEditData(undefined);
        setNewService({
            serviceName: '',
            timeConsuming: 0,
            priceLowerBound: 0,
            priceUpperBound: 0,
            number: 0,
            color: '#2196F3'
        });
        setOpen(false);
    };

    const checkInputData = () => {
        if(newService.serviceName === ''){
            swal("資料填寫不完整","請將資料填寫完成再送出","warning");
            return false;
        }
        if(newService.timeConsuming === 0){
            swal("資料填寫不完整","請將資料填寫完成再送出","warning");
            return false;
        }
        if(newService.priceLowerBound === 0){
            swal("資料填寫不完整","請將資料填寫完成再送出","warning");
            return false;
        }
        if(newService.priceUpperBound === 0){
            swal("資料填寫不完整","請將資料填寫完成再送出","warning");
            return false;
        }
        return true;
    }

    const handleChange = e => {
        if(e.target.type === "number"){
            setNewService({ ...newService, [e.currentTarget.id]: parseInt(e.currentTarget.value) });
        }
        else{
            setNewService({ ...newService, [e.currentTarget.id]: e.currentTarget.value });
        }
    };

    const handleSubmit = () => {

        if(checkInputData === false){
            return;
        }

        if(props.editData)
        {
            patchData("SalonService", newService).then(res => {
                if(res != null){
                    swal("修改成功", "資料庫資料已更新", "success");
                    props.getServices();
                }
                else{
                    swal("修改失敗", "系統出現不知名錯誤，請聯絡管理員", "error");
                }
                closeModel();
            });
        }
        else{
            postData("SalonService", newService).then(res => {
                if(res != null){
                    swal("新增成功", "資料已新增置資料庫", "success");
                    props.getServices();
                }
                else{
                    swal("新增失敗", "系統出現不知名錯誤，請聯絡管理員", "error");
                }
                closeModel();
            });
        }
    };

    return (
        <div>
            <Button onClick={openModel}>新增服務項目</Button>
            <Modal
                open={open}
                onClose={closeModel}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack spacing={2} sx={{ width: '100%' }}>
                        <TextField id="serviceName" value={newService.serviceName} label="服務名稱" onChange={handleChange} required variant="outlined"/>
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <TextField id="timeConsuming" value={newService.timeConsuming} label="預估時程(分鐘)" onChange={handleChange} required type="number" variant="outlined"/>
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <TextField id="priceLowerBound" value={newService.priceLowerBound} label="價格下限" onChange={handleChange} required type="number" variant="outlined"/>
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <TextField id="priceUpperBound" value={newService.priceUpperBound} label="價格上限" onChange={handleChange} required type="number" variant="outlined"/>
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <TextField id="number" value={newService.number} label="排序" onChange={handleChange} required type="number" variant="outlined"/>
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <CompactPicker color={newService.color} onChange={handleChangeColor} />
                    </Stack>
                    <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                        <Button variant="contained" onClick={handleSubmit}>{props.editData ? '儲存' : '新增'}</Button>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
}

export default ServiceModal
